module.exports = __webpack_public_path__ + "userfiles/yoli/img/text.df09c296.png";